import type { FC } from 'react';
import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import Flex from '@atlaskit/primitives/components/flex';
// oxlint-disable-next-line @atlaskit/design-system/no-emotion-primitives
import { xcss } from '@atlaskit/primitives/xcss';
import Tile from '@atlaskit/tile/tile';

import { fg } from '@confluence/feature-gating';
import { ContentIcon } from '@confluence/icons/entry-points/ContentIcon.ts';
import {
	getEmojiDraftFromProperties,
	getEmojiPublishedFromProperties,
} from '@confluence/emoji-title/entry-points/transformer.ts';
import {
	getEmojiFromTitle,
	removeEmojiFromTitle,
} from '@confluence/emoji-title/entry-points/helpers.ts';

const iconBorderStyles = xcss({
	borderColor: 'color.border',
	borderStyle: 'solid',
	borderRadius: 'radius.small',
	borderWidth: 'border.width',
	height: '32px',
	width: '32px',
});

export type ContentIconProps = {
	contentType: string;
	emoji?: string;
	subType?: string | null;
};

export const EmojiContentIcon: FC<ContentIconProps> = ({ contentType, emoji, subType }) => {
	if (fg('confluence_frontend_tile_object_system_migration')) {
		return (
			<Tile
				label=""
				size="medium"
				backgroundColor="transparent"
				hasBorder
				testId="emoji-content-icon-tile"
			>
				<ContentIcon type={contentType} subType={subType} emoji={emoji} />
			</Tile>
		);
	}

	return (
		<Flex alignItems="center" justifyContent="center" xcss={iconBorderStyles}>
			<ContentIcon type={contentType} subType={subType} emoji={emoji} />
		</Flex>
	);
};

export const getEmoji = (
	content: any,
): {
	hasEmojiProperty: boolean;
	emoji: string;
} => {
	const emojiPropertyDraft = getEmojiDraftFromProperties(content);
	const emojiPropertyPublished = getEmojiPublishedFromProperties(content);
	const emojiProperty = content.status === 'draft' ? emojiPropertyDraft : emojiPropertyPublished;

	const emoji = emojiProperty || getEmojiFromTitle(content.title);

	return {
		hasEmojiProperty: Boolean(emojiProperty),
		emoji,
	};
};

export const getTitle = (originalTitle: any, hasEmojiProperty: any): any =>
	hasEmojiProperty ? originalTitle : removeEmojiFromTitle(originalTitle);
